import React from "react"
import classNames from "classnames"
import { telephoneStrip } from "../../utils/utils"

const Phone = ({
  phoneNumber,
  countryCode = "1",
  textOnly,
  className,
  language
}) => {
  const cleanNumber = telephoneStrip(phoneNumber)
  const telTo = `tel:+${countryCode}${cleanNumber}`

  const classes = classNames(className, {
    phonenumber: true,
    phonenumber__link: !textOnly
  })

  return (
    <>
      {textOnly ? (
        <p className={classes + " mt-0"}>{phoneNumber}</p>
      ) : (
        <a
          href={telTo}
          title={language === "es" ? "Llamanos" : "Give us a call"}
          className={classes}>
          {phoneNumber}
        </a>
      )}
    </>
  )
}

export default Phone
